import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("pr_lang") || "tr");

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
    localStorage.setItem("pr_lang", lang);
  }, [lang]);

  const t = translations[lang] || translations.tr;
  const dir = (LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0]).dir;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
